import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListPositionResource: IResourceConfig = {
    title: 'Посади',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            isRequired: true,
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: ['id', 'title', 'code', 'isActive', 'externalCode'],
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/positions',
    pageUrl: '/settings/positions',
    primaryFieldCode: 'code',
    /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
    detailConfig: { onButtons: dictionaryDetailButtons },
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
